<template>
  <div class="mail-tac-status" :class="{ 'mail-tac-error': state === 'error' }">
    <div class="mail-tac-line">
      <div class="mail-tac-time"><v-icon aria-hidden="true">mdi-database-clock-outline</v-icon><span v-if="syncedAt">TAC aktualisiert: <strong>{{ formatDate(syncedAt, true) }}</strong></span><span v-else>TAC-Daten noch nicht geladen</span></div>
      <button :disabled="busy || state === 'running'" @click="$emit('sync')">{{ busy || state === 'running' ? 'Wird synchronisiert …' : 'Synchronisieren' }}</button>
    </div>
    <p v-if="error" class="mail-tac-error-text" role="status">{{ error }}<span v-if="syncedAt"> Der letzte erfolgreiche Stand bleibt sichtbar.</span></p>
  </div>
</template>
<script>
import { formatDate } from "@/api/aiMails"
export default { props: { syncedAt: String, state: String, error: String, busy: Boolean }, methods: { formatDate } }
</script>
